import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as m } from "../SvgIcon.js";
const e = (r) => /* @__PURE__ */ o(m, { ...r, children: /* @__PURE__ */ o("path", { d: "M10 0C4.475 0 0 4.475 0 10s4.475 10 10 10 10-4.475 10-10S15.525 0 10 0ZM7.525 13.116l-.973.972-4.11-4.121 4.11-4.144.973.973-3.171 3.17 3.17 3.15Zm4.364-7.613-2.651 9.956H7.812l.287-1.05 2.663-9.956h1.415l-.287 1.05Zm1.548 8.585-.973-.972 3.171-3.15-3.17-3.17.972-.973 4.121 4.144-4.121 4.121Z" }) });
export {
  e as SourceCode2
};
//# sourceMappingURL=SourceCode2.js.map
